import {
    createContext,
    useCallback,
    useContext,
    useState,
    type ReactNode
} from 'react';

export type SidebarContextValue = {
    sidebarOpen: boolean;
    setSidebarOpen: (open: boolean) => void;
    toggleSidebar: () => void;
};

const SidebarContext = createContext<SidebarContextValue | null>(null);

export const useSidebarOptional = () => useContext(SidebarContext);

export const useSidebar = () => {
    const ctx = useContext(SidebarContext);
    if (!ctx) {
        throw new Error('useSidebar must be used within SidebarContextProvider');
    }
    return ctx;
};

type SidebarContextProviderProps = {
    children: ReactNode;
};

export const SidebarContextProvider = ({ children }: SidebarContextProviderProps) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = useCallback(() => {
        setSidebarOpen((open) => !open);
    }, []);

    const value: SidebarContextValue = {
        sidebarOpen,
        setSidebarOpen,
        toggleSidebar
    };

    return (
        <SidebarContext.Provider value={value}>
            {children}
        </SidebarContext.Provider>
    );
};
